import Component from "gia/Component";
import { AddToCart } from "../components/CartEvents.js";
import Accordion from "accordion-js";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.form = this.DOM.view.querySelector('form[action$="/cart/add"]');

    //
    this.buildAccordions();
    gsap.delayedCall(0.5, () => this.listenerScroll());

    this.events();
  }

  buildAccordions() {
    this.instanceAccordion = new Accordion(
      this.DOM.view.querySelector(".accordion-container")
    );
  }

  events() {
    this.DOM.form.addEventListener("submit", (e) => {
      e.preventDefault();
      const data = new FormData(this.DOM.form);
      AddToCart(data);
      // axios.post(window.Shopify.routes.root + "cart/add.js", data).then((response) => gsap.delayedCall(1, () => Channels.emit("cart::open")));
      return false;
    });
  }

  listenerScroll() {
    this.stScroll = ScrollTrigger.create({
      trigger: this.ref.list[0],
      scroller: this.ref.scrollzone[0],
      start: "top 5%",
      onEnter: () => this.DOM.view.classList.add("is-reduced"),
      onLeaveBack: () => this.DOM.view.classList.remove("is-reduced"),
    });
  }

  unmount() {
    this.stScroll.kill();
    this.instanceAccordion.destroy();
  }
}
